export const closeModalBeforeLeave = () => {
    if (document.body.classList.contains('modal-open')) {
        document.body.classList.remove('modal-open');
        document.querySelector('.modal').remove();
    }
};
